import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { FormGroup } from '@angular/forms';
import {
  ExamAddressesClient,
  ExamAddressResponse,
  ExamAddressUpdateRequest,
} from '../../../generated-client/generated-api-client';
import { Observable } from 'rxjs';
import { ErrorProcessorService } from '../../../services/error-processor.service';
import {isFormModifiedDataService} from "../../../services/data-services/navigation-data-services";

@Component({
  selector: 'app-exam-address-edit',
  templateUrl: './exam-address-edit.component.html',
  styleUrls: ['./exam-address-edit.component.sass'],
})
export class ExamAddressEditComponent implements OnInit {
  id: string;
  response!: Observable<ExamAddressResponse>;

  constructor(
    private route: ActivatedRoute,
    private titleService: Title,
    private router: Router,
    private client: ExamAddressesClient,
    private errorProcessorService: ErrorProcessorService,
    private _isFormModifiedDataService: isFormModifiedDataService
  ) {
    this.id = '';
    this.titleService.setTitle('Vizsgahelyszín módosítása');
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.id = params.get('id') ?? '';
    });
  }

  ngOnInit(): void {
    this.response = this.client.get(this.id);
  }

  async onSubmit(form: FormGroup): Promise<void> {
    const request: ExamAddressUpdateRequest = {
      id: form.get('id')?.value === '' ? null : form.get('id')?.value,
      city: form.get('city')?.value === '' ? null : form.get('city')?.value,
      postCode: form.get('postCode')?.value === '' ? null : form.get('postCode')?.value,
      line1: form.get('line1')?.value === '' ? null : form.get('line1')?.value,
      line2: form.get('line2')?.value === '' ? null : form.get('line2')?.value,
    };
    const response = await this.client.edit(request);
    response.subscribe(
      next => {
        this._isFormModifiedDataService.isFormModified = false;
        this.router.navigate(['/exam-addresses/']);
      },
      error => this.errorProcessorService.processError(error, true)
    );
  }
}
